import Banner from "../../sections/common/banner";
import { useLangagesStore } from "../../../context/langages";
import { data as dataES } from "../../../globals/data/es/politicas-privacidad.js";
import { data as dataEN } from "../../../globals/data/en/politicas-privacidad.js";
import { data as dataCN } from "../../../globals/data/zh/politicas-privacidad.js";
import SectionPrivacyPolicy from "../../sections/home/index/section-privacy-policy";

export default function PrivacyPolicyPage() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEN : language === "cn" ? dataCN : dataES;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionPrivacyPolicy _data={data} />
        </>
    )
}